import React from "react";
import ApAnnotationCard from "./ApAnnotationCard";

class ApAnnotationPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderCard(index, annotation) {
    return (
      <ApAnnotationCard
        id={index}
        key={annotation.id}
        onAnnotationCardCreated={ref =>
          this.props.onAnnotationCardCreated(index, ref)
        }
        text={annotation.text}
        onClick={() => this.props.toggleAnnotation(index)}
        active={this.props.annotationStates[index]}
      />
    );
  }

  toggleAnnotation(index) {}

  render() {
    const cards = this.props.annotations.map((value, index) => {
      return this.renderCard(index, value);
    });
    return (
      <div
        className="ApAnnotationPanel"
        onScroll={() => this.props.forceUpdate()}
      >
        {cards}
      </div>
    );
  }
}

export default ApAnnotationPanel;



// WEBPACK FOOTER //
// ./src/components/approval/ApAnnotationPanel.js